module.exports = __webpack_public_path__ + "static/media/8OLA8.fe41c914.jpg";